export default function(item) {
  /* Clean the Reason code on an item.
   *
   * This includes removing a code if not appropriate, as well as
   * displaying errors if a reason code is not included when it's required
   */
  if (item == null) {
    return;
  }
  // Remove reason codes if not appropriate
  if (item.status <= "0" && item.requires_reason == 0) {
    // false
    item.reason_code = "";
    item.reason_name = "";
  }
  // Display an error if a reason is required but it's not set
  item.reason_error =
    item.can_have_reason && item.requires_reason == 1 && item.reason_code == "";
  return item;
}
